module.exports = __webpack_public_path__ + "img/vehicle-options-black-ford.4af8c08f.png";